<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body position-relative">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <h6>
                                                {{
                                                    $t(
                                                        "form_configuration_description"
                                                    )
                                                }}
                                                <br />
                                                {{
                                                    $t(
                                                        "form_configuration_description_2"
                                                    )
                                                }}
                                                <br />
                                                {{
                                                    $t(
                                                        "form_configuration_description_3"
                                                    )
                                                }}
                                            </h6>
                                            <br />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name: 'name',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.name.$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectCountry
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'country_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.country_id
                                                        .$model
                                                "
                                                :label="$t('country')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('country_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectLanguage
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'language_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.language_id
                                                        .$model
                                                "
                                                :label="$t('language')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('language_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectAsync
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'provider_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.provider_id
                                                        .$model
                                                "
                                                :label="$t('provider')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('provider_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                :name="'provider_id'"
                                                size="sm"
                                                :optionsValue="'id'"
                                                :optionsLabel="'name'"
                                                :endpoint="'provider'"
                                            />
                                            <SelectAsync
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'template_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.template_id
                                                        .$model
                                                "
                                                :label="$t('template')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('template_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                :name="'template_id'"
                                                size="sm"
                                                :optionsValue="
                                                    formatOptionValueTemplate
                                                "
                                                :optionsLabel="'name'"
                                                endpoint="/templates.api"
                                            />

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name: 'final_url',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.final_url
                                                        .$model
                                                "
                                                :placeholder="
                                                    $t(
                                                        'you_will_be_able_to_see_this_code_after_saving_the_campaign'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                :label="$t('URL')"
                                                size="sm"
                                                readonly
                                            >
                                                <template #description>
                                                    <small class="py-2">
                                                        <a
                                                            class="text-muted font-italic"
                                                            :href="
                                                                forms.general
                                                                    .final_url
                                                            "
                                                            target="_blank"
                                                        >
                                                            {{
                                                                forms.general
                                                                    .final_url
                                                            }}
                                                        </a>
                                                    </small>
                                                </template>
                                            </CInput>

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'form_version',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general
                                                        .form_version.$model
                                                "
                                                :label="$t('version')"
                                                :placeholder="
                                                    $t('select_an_version')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                                type="number"
                                            />

                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name: 'type_url',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.type_url
                                                        .$model
                                                "
                                                :label="$t('type_url')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                :options="[
                                                    {
                                                        label: $t(
                                                            'without_configuration'
                                                        ),
                                                        value: 0,
                                                    },
                                                    {
                                                        label: $t('slug'),
                                                        value: 1,
                                                    },
                                                    {
                                                        label: $t('custom'),
                                                        value: 2,
                                                    },
                                                ]"
                                                size="sm"
                                                type="text"
                                                :invalidFeedback="
                                                    $t('type_url_is_required')
                                                "
                                            />

                                            <CInput
                                                v-if="
                                                    $v.forms.general.type_url
                                                        .$model == 1
                                                "
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name: 'slug_url',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.slug_url
                                                        .$model
                                                "
                                                :label="$t('slug_url')"
                                                :placeholder="
                                                    $t('enter_the_slug_url')
                                                "
                                                :invalidFeedback="
                                                    $t(
                                                        'Only latters and dashes'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                                type="text"
                                            />

                                            <CInput
                                                v-if="
                                                    $v.forms.general.type_url
                                                        .$model == 2
                                                "
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'custom_url',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.custom_url
                                                        .$model
                                                "
                                                :label="$t('custom_url')"
                                                :placeholder="
                                                    $t('enter_the_custom_url')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                                type="url"
                                            />
                                        </CCard>
                                    </CTab>
                                    <CTab
                                        :title="$t('sponsor')"
                                        :disabled="$route.query.type != 'edit'"
                                    >
                                        <CCard>
                                            <CCardHeader>
                                                <!-- Button add -->
                                                <CButton
                                                    color="success"
                                                    class="button shadow"
                                                    @click="
                                                        modals.sponsors.show = true
                                                    "
                                                >
                                                    <span class="button__icon">
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilPlus
                                                            "
                                                        />
                                                    </span>
                                                    <span class="button__text">
                                                        {{ $t("add") }}
                                                    </span>
                                                </CButton>
                                            </CCardHeader>
                                            <CCardBody>
                                                <!-- Table -->
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    v-if="
                                                        tables.sponsors.items
                                                            .length > 0
                                                    "
                                                    :items="
                                                        tables.sponsors.items
                                                    "
                                                    :fields="
                                                        traslateLabels(
                                                            tables.sponsors
                                                                .fields
                                                        )
                                                    "
                                                    hover
                                                >
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <td class="text-center">
                                                            <CButton
                                                                color="danger"
                                                                variant="outline"
                                                                square
                                                                size="sm"
                                                                @click="
                                                                    deleteSponsor(
                                                                        index
                                                                    )
                                                                "
                                                            >
                                                                <CIcon
                                                                    class="icon"
                                                                    :content="
                                                                        $options
                                                                            .icons
                                                                            .cilTrash
                                                                    "
                                                                />
                                                            </CButton>
                                                        </td>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>

                                            <!-- Modal sponsors -->
                                            <CModal
                                                :title="$t('add_sponsor')"
                                                color="primary"
                                                :show.sync="
                                                    modals.sponsors.show
                                                "
                                            >
                                                <SelectAsync
                                                    :label="$t('campaign')"
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'provider_is_required'
                                                        )
                                                    "
                                                    :name="'campaign_id'"
                                                    :horizontal="true"
                                                    size="sm"
                                                    endpoint="/campaigns.api/sponsorList"
                                                    :formatOptions="
                                                        formatSponsorList
                                                    "
                                                    :isValid="
                                                        checkIfFormValid({
                                                            form_name:
                                                                'sponsors',
                                                            field_name:
                                                                'campaign_id',
                                                        })
                                                    "
                                                    :value.sync="
                                                        $v.forms.sponsors
                                                            .campaign_id.$model
                                                    "
                                                />
                                                <template #footer>
                                                    <!-- Button add sponsor  -->
                                                    <CButton
                                                        color="success"
                                                        size="lg"
                                                        class="m-2 p-0 btn-acction"
                                                        @click="addSponsor()"
                                                    >
                                                        <span
                                                            class="block-icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilPlus
                                                                "
                                                            />
                                                        </span>
                                                        <span class="text">
                                                            {{ $t("add") }}
                                                        </span>
                                                    </CButton>
                                                    <!-- Button close modal -->
                                                    <CButton
                                                        color="primary"
                                                        size="lg"
                                                        class="m-2 p-0 btn-acction"
                                                        @click="
                                                            modals.sponsors.show = false
                                                        "
                                                    >
                                                        <span
                                                            class="block-icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilArrowThickFromRight
                                                                "
                                                            />
                                                        </span>
                                                        <span class="text">
                                                            {{ $t("close") }}
                                                        </span>
                                                    </CButton>
                                                </template>
                                            </CModal>
                                        </CCard>
                                    </CTab>
                                    <CTab
                                        :title="$t('coregister')"
                                        :disabled="$route.query.type != 'edit'"
                                    >
                                        <CCard>
                                            <CCardHeader>
                                                <!-- Button add -->
                                                <CButton
                                                    color="success"
                                                    class="button shadow"
                                                    @click="
                                                        modals.coregisters.show = true
                                                    "
                                                >
                                                    <span class="button__icon">
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilPlus
                                                            "
                                                        />
                                                    </span>
                                                    <span class="button__text">
                                                        {{ $t("add") }}
                                                    </span>
                                                </CButton>
                                            </CCardHeader>
                                            <CCardBody>
                                                <!-- Table -->
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    v-if="
                                                        tables.coregisters.items
                                                            .length > 0
                                                    "
                                                    :items="
                                                        tables.coregisters.items
                                                    "
                                                    :fields="
                                                        traslateLabels(
                                                            tables.coregisters
                                                                .fields
                                                        )
                                                    "
                                                    hover
                                                >
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <td class="text-center">
                                                            <CButton
                                                                color="danger"
                                                                variant="outline"
                                                                square
                                                                size="sm"
                                                                @click="
                                                                    deleteCoregister(
                                                                        index
                                                                    )
                                                                "
                                                            >
                                                                <CIcon
                                                                    class="icon"
                                                                    :content="
                                                                        $options
                                                                            .icons
                                                                            .cilTrash
                                                                    "
                                                                />
                                                            </CButton>
                                                        </td>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>

                                            <!-- Modal coregister -->
                                            <CModal
                                                :title="$t('add_coregister')"
                                                color="primary"
                                                :show.sync="
                                                    modals.coregisters.show
                                                "
                                            >
                                                <SelectAsync
                                                    :label="$t('coregister')"
                                                    :placeholder="
                                                        $t('Select an option')
                                                    "
                                                    :optionsLabel="'name'"
                                                    optionsValue="client_id"
                                                    :horizontal="true"
                                                    size="sm"
                                                    endpoint="/getCoregisterList"
                                                    :value.sync="
                                                        $v.forms.coregisters
                                                            .client_id.$model
                                                    "
                                                />
                                                <SelectFieldsAdvance
                                                    :label="$t('field')"
                                                    :placeholder="
                                                        $t('select_a_field')
                                                    "
                                                    :invalidFeedback="
                                                        $t('field_is_required')
                                                    "
                                                    size="sm"
                                                    :optionsLabel="'name'"
                                                    optionsValue="id"
                                                    :horizontal="true"
                                                    :typeSelect="'SearchSelect'"
                                                    :value.sync="
                                                        $v.forms.coregisters
                                                            .field_id.$model
                                                    "
                                                    :formatOptions="
                                                        formatFieldsList
                                                    "
                                                />
                                                <SelectAsync
                                                    :label="$t('options')"
                                                    :placeholder="
                                                        $t('select_an_option')
                                                    "
                                                    :options="
                                                        this.fieldsOptions
                                                            .options
                                                    "
                                                    :horizontal="true"
                                                    size="sm"
                                                    :typeSelect="'SearchSelect'"
                                                    :isValid="
                                                        checkIfCoregValid()
                                                    "
                                                    :value.sync="
                                                        $v.forms.coregisters
                                                            .value.$model
                                                    "
                                                />
                                                <template #footer>
                                                    <!-- Button add coregister  -->
                                                    <CButton
                                                        color="success"
                                                        size="lg"
                                                        class="m-2 p-0 btn-acction"
                                                        @click="addCoregister()"
                                                    >
                                                        <span
                                                            class="block-icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilPlus
                                                                "
                                                            />
                                                        </span>
                                                        <span class="text">
                                                            {{ $t("add") }}
                                                        </span>
                                                    </CButton>
                                                    <!-- Button close modal -->
                                                    <CButton
                                                        color="primary"
                                                        size="lg"
                                                        class="m-2 p-0 btn-acction"
                                                        @click="
                                                            modals.coregisters.show = false
                                                        "
                                                    >
                                                        <span
                                                            class="block-icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilArrowThickFromRight
                                                                "
                                                            />
                                                        </span>
                                                        <span class="text">
                                                            {{ $t("close") }}
                                                        </span>
                                                    </CButton>
                                                </template>
                                            </CModal>
                                        </CCard>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <ButtonSave
                                    color="success"
                                    @click="sendFormGeneral"
                                />
                                <!-- Button back -->
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import SelectAsync from "£lement/SelectAsync";
import SelectFieldsAdvance from "£lement/SelectFieldsAdvance";
import { ModelSelect } from "vue-search-select";
import ButtonSave from "~/components/ButtonSave.vue";
import ButtonBack from "£lement/ButtonBack";
/**
 * Mixins
 */
import pageMixin from "~/mixins/page";
import { validationMixin } from "vuelidate";

/**
 * Others
 */
import "vue-search-select/dist/VueSearchSelect.css";
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
} from "@coreui/icons";

import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

const validSlugFormat = (value) => {
    return /^[a-zA-Z--_]+$/.test(value);
};

// Validate URL format contains http:// or https://
const validUrlFormat = (value) => {
    let url;
    try {
        url = new URL(value);
        return true;
    } catch (_) {
        return value === "" || !value ? true : false;
    }
};

export default {
    name: "FormViewPages",
    middleware: ["auth", "page"],
    components: {
        SelectCountry,
        SelectLanguage,
        SelectAsync,
        SelectFieldsAdvance,
        ModelSelect,
        ButtonBack,
        ButtonSave,
    },

    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
    },
    mixins: [validationMixin, pageMixin],
    data() {
        return {
            forms: {
                info: {
                    id: "",
                },
                general: {
                    name: "",
                    country_id: "",
                    language_id: "",
                    provider_id: "",
                    template_id: "",
                    form_version: null,
                    custom_url: null,
                    slug_url: null,
                    type_url: null,
                    final_url: null,
                },
                sponsors: {
                    campaign_id: null,
                    form_id: null,
                },
                coregisters: {
                    client_id: null,
                    form_id: null,
                    field_id: null,
                    value: null,
                },
            },
            tables: {
                sponsors: {
                    items: [],
                    fields: [
                        {
                            key: "SponsorName",
                            label: "sponsor",
                        },
                        {
                            key: "CampaignName",
                            label: "campaign",
                        },
                        {
                            key: "options",
                            label: "options",
                            _style: "width:25%",
                            _classes: "text-center",
                        },
                    ],
                    order: "asc",
                    rows: 10,
                    page: 1,
                    total_pages: 1,
                    loading: true,
                },
                coregisters: {
                    items: [],
                    fields: [
                        {
                            key: "CoregisterName",
                            label: "Coregister",
                        },
                        {
                            key: "CampaignName",
                            label: "Campaign",
                        },
                        {
                            key: "FieldName",
                            label: "Field Name",
                        },
                        {
                            key: "FormCoregisterValue",
                            label: "value",
                        },
                        {
                            key: "options",
                            label: "options",
                            _style: "width:25%",
                            _classes: "text-center",
                        },
                    ],
                    order: "asc",
                    rows: 10,
                    page: 1,
                    total_pages: 1,
                    loading: true,
                },
            },
            fieldsOptions: {
                allFields: [],
                options: ["", ""],
            },
            modals: {
                sponsors: {
                    show: false,
                },
                coregisters: {
                    show: false,
                },
            },
            messages: {
                create: {
                    header: "provider",
                    body: "provider_created.",
                },
                update: {
                    header: "provider",
                    body: "provider_updated.",
                },
                error: {
                    header: "error!",
                    body: "error!",
                },
                sponsors: {
                    create: {
                        header: "sponsor",
                        body: "sponsor added.",
                    },
                    delete: {
                        header: "sponsor",
                        body: "sponsor deleted.",
                    },
                },
                coregisters: {
                    create: {
                        header: "coregister",
                        body: "coregister added.",
                    },
                    delete: {
                        header: "coregister",
                        body: "coregister deleted.",
                    },
                },
            },
            endpoints: {
                form: "/form",
                add_sponsor: "/addDeliveryCampaign",
                delete_sponsor: "/",
            },
            page: {
                _loading: true,
            },
        };
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
        }),
        title_page: function () {
            let title_page = "new_form";
            if (this.$route.query.type == "edit") {
                title_page = "edit_form";
            }
            return this.$t(title_page);
        },
        view_type: function () {
            return this.$route.query.type;
        },
        form_uuid: function () {
            return this.$route.query.uuid;
        },
        form_id: function () {
            return this.forms.info.id;
        },
    },
    watch: {
        "forms.general": {
            handler: function (val, oldVal) {
                let url =
                    "https://page.leadgrease.com/:tenant_id/:slug/:form_version/index.html";
                url = url.replace(":tenant_id", this.user["custom:tenant_id"]);

                if (
                    this.forms.general.form_version &&
                    this.forms.general.form_version > 0
                ) {
                    url = url.replace(
                        ":form_version",
                        this.forms.general.form_version
                    );
                } else {
                    url = url.replace("/:form_version", "");
                }

                if (
                    this.forms.general.type_url == 1 &&
                    this.forms.general.slug_url
                ) {
                    url = url.replace(":slug", this.forms.general.slug_url);
                } else {
                    url = url.replace("/:slug", "");
                }

                if (this.forms.general.type_url == 2) {
                    url = this.forms.general.custom_url;
                }
                this.forms.general.final_url = url;
            },
            deep: true,
        },
        "forms.coregisters.field_id": {
            handler(newValue) {
                const fields = this.fieldsOptions.allFields.find(
                    (element) => element.id == newValue
                );
                var options = [];

                if (fields && fields.options) {
                    if (fields.options.includes(",\n")) {
                        options = fields.options.split(",\n");
                    } else if (fields.options.includes(",")) {
                        options = fields.options.split(",");
                    }
                }
                this.fieldsOptions.options = this.formatOptionsList(options);
            },
            deep: true,
        },
    },

    validations: {
        forms: {
            general: {
                name: {
                    required,
                },
                country_id: {
                    required,
                },
                language_id: {
                    required,
                },
                provider_id: {
                    required,
                },
                template_id: {
                    required,
                },
                form_version: {},
                custom_url: {
                    validUrlFormat,
                },
                slug_url: {
                    validSlugFormat,
                },
                type_url: {
                    required,
                },
                final_url: {},
            },
            sponsors: {
                campaign_id: {
                    required,
                },
            },
            coregisters: {
                client_id: {
                    required,
                },
                field_id: {
                    required,
                },
                value: {
                    required,
                },
            },
        },
    },
    methods: {
        async loadSponsors() {
            if (this.view_type == "edit") {
                let table_data = await this.loadData({
                    url: "/getSponsorByForm",
                    url_param: this.form_uuid,
                });

                this.loadTable({
                    table_name: "sponsors",
                    data: table_data,
                    extra_fields: [
                        { label: "campaign_id", name: "CampaingUuid" },
                    ],
                });

                this.forms.sponsors.form_id = this.form_uuid;
            }
        },
        async loadCoregisters() {
            if (this.view_type == "edit") {
                let table_data = await this.loadData({
                    url: "/getCoregisterByForm",
                    url_param: this.form_uuid,
                });

                this.loadTable({
                    table_name: "coregisters",
                    data: table_data,
                    extra_fields: [
                        {
                            label: "FormCoregisterUuid",
                            name: "FormCoregisterUuid",
                        },
                    ],
                });
            }
        },
        async getFormId() {
            let query = {
                query: {
                    where: {
                        uuid: this.form_uuid,
                    },
                },
            };
            let response = await this.fetcher({
                url: `form`,
                method: "GET",
                query: query,
            });
            let form;
            form = response.find((element) => element.uuid == this.form_uuid);
            this.forms.info.id = form.id;
        },
        async addCoregister() {
            if (this.forms.coregisters.value == "null") {
                this.forms.coregisters.value = null;
            }
            console.log(this.forms.coregisters);
            this.forms.coregisters.form_id = this.form_id.toString();
            this.forms.coregisters.client_id =
                this.forms.coregisters.client_id.toString();
            this.forms.coregisters.field_id =
                this.forms.coregisters.field_id;
            let response = await this.fetcher({
                url: `form.api/coregister`,
                method: "POST",
                data: this.forms.coregisters,
            });
            this.loadCoregisters();

            this.modals.coregisters.show = false;
        },
        formatOptionValueTemplate(option) {
            return parseInt(option["id"]);
        },
        formatOptionsList(data) {
            console.log(data);
            return data;
            if (data[0] === undefined) {
                var noOption = [];
                noOption[0] = {
                    text: "No options",
                    value: "null",
                };
                return noOption;
            }
            let options = data.map((item) => {
                return {
                    text: item,
                    value: item,
                };
            });

            return options;
        },
        checkIfCoregValid() {
            if (this.forms.coregisters.value == "null") {
                return false;
            } else if (this.forms.coregisters.value == null) {
                return null;
            }
            return true;
        },
        formatSponsorList(data) {
            let options = data.items.map((item) => {
                return {
                    text: item.campaign_name,
                    value: item.campaign_uid,
                };
            });
            return options;
        },
        formatFieldsList(data) {
            var fieldsTypeOptions = [];
            data.forEach((element) => {
                if (element.type == "options" && element.isCustom == "1") {
                    fieldsTypeOptions.push(element);
                }
            });

            this.fieldsOptions.allFields = fieldsTypeOptions;
            var items;
            items = fieldsTypeOptions.map((item) => {
                let value;
                value = item["id"];
                let text;
                text = item["name"];

                return {
                    value,
                    text,
                    label: text,
                };
            });
            return items;
        },
        async addSponsor() {
            await this.sendData({
                url: `/form.api/${this.form_uuid}/addSponsor/${this.forms.sponsors.campaign_id}`,
                method: "POST",
            });

            this.loadSponsors();
            this.modals.sponsors.show = false;
        },
        async deleteSponsor(index) {
            try {
                let item = this.tables.sponsors.items[index];
                const { status } = await this.deleteData({
                    url: `/form.api/${this.form_uuid}/deleteSponsor/${item.campaign_id}`,
                });
                if (status) this.loadSponsors();
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async deleteCoregister(index) {
            try {
                let item = this.tables.coregisters.items[index];
                const { status } = await this.deleteData({
                    url: `/form.api/coregister/${item.FormCoregisterUuid}`,
                });
                if (status) this.loadCoregisters();
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async updateForms() {
            await this.updateForm({
                form_name: "general",
                url: "/form",
                url_param: this.form_uuid,
            });
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        async sendFormGeneral() {
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
            let { status } = await this.sendForm({
                form_name: "general",
                url: "/form",
                url_param: this.form_uuid,
            });
            if (status) this.$router.push({ name: "forms" });
        },
    },
    async mounted() {
        this.loadSponsors();
        this.loadFieldsAdvance();
        this.loadCoregisters();
        this.updateForms();
        this.getFormId();
    },
};
</script>

<style>
@media print {
    a::after {
        content: " (" attr(href) ") ";
    }
}
</style>